"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.passiveEventSupported = void 0;
var passiveSupported = null;
function passiveEventSupported() {
    // memoize support to avoid adding multiple test events
    if (typeof passiveSupported === "boolean")
        return passiveSupported;
    var supported = false;
    try {
        var options = {
            get passive() {
                supported = true;
                return false;
            },
        };
        window.addEventListener("test", null, options);
        window.removeEventListener("test", null, options);
    }
    catch (err) {
        supported = false;
    }
    passiveSupported = supported;
    return passiveSupported;
}
exports.passiveEventSupported = passiveEventSupported;
//# sourceMappingURL=get-passive-event-support.js.map